import { render, staticRenderFns } from "./PrivacyAgreementModal.vue?vue&type=template&id=063dd848&scoped=true&"
import script from "./PrivacyAgreementModal.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreementModal.vue?vue&type=style&index=0&id=063dd848&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dd848",
  null
  
)

export default component.exports